@if (mode() === 'view') {
    <div class="o-grid">
        <div class="o-grid__row">
            <div class="o-grid__item">
                <div class="c-info__block">
                    <h5>Special Needs</h5>
                    <span id="specialNeeds">{{ formGroup().value.specialNeeds || 'Unspecified' }}</span>
                </div>
            </div>
        </div>
    </div>
} @else if (mode() === 'edit') {
    <div class="o-grid">
        <div class="o-grid__row">
            <div class="o-grid__field">
                <mds-text-field
                    id="specialNeeds"
                    [formCtrl]="formGroup().controls.specialNeeds"
                    placeholder="Type here..."
                    appearance="outline"
                    inputType="text"
                    label="Special Needs"
                    width="100%"
                ></mds-text-field>
            </div>
        </div>
    </div>
}
